import React from "react";
import RequestDetailModal from "./RequestDetailModal";

const ImportationModal = (props) => <RequestDetailModal {...props} />;

export default ImportationModal;
